var React = require('react');

function Telegram (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.17496 15.0308C7.61352 15.0308 7.80729 14.8302 8.05208 14.5922L10.3911 12.3179L7.47348 10.5585","fill":"white","key":0}),React.createElement("path",{"d":"M7.47321 10.559L14.5428 15.7821C15.3495 16.2272 15.9317 15.9967 16.1327 15.0331L19.0104 1.47242C19.305 0.29121 18.5601 -0.244533 17.7883 0.105845L0.890687 6.6215C-0.262735 7.08414 -0.256011 7.72763 0.680442 8.01436L5.01676 9.3678L15.0558 3.03429C15.5297 2.7469 15.9647 2.90141 15.6077 3.21825","fill":"white","key":1})]);
}

Telegram.defaultProps = {"width":"20","height":"16","viewBox":"0 0 20 16","fill":"none"};

module.exports = Telegram;

Telegram.default = Telegram;
